<script>
    export let date;

    function hrDate(date) {
        return date.substr(0, 19).replace("T", " ");
    }
</script>

<span class="date">{hrDate(date)}</span>

<style>
    .date {
        font-family: "Courier", "Courier New";
    }
</style>